const EMOTIONS = [
  "angry ",
  "disgust ",
  "fear ",
  "happy ",
  "neutral ",
  "sad ",
  "surprise ",
];

const NO_MODEL= "❌ model not loaded yet";

const PRED_RESIZE_SHAPE = [1, 80, 80, 3];

const RESIZE_SHAPE = [80, 80];

export { EMOTIONS, NO_MODEL, PRED_RESIZE_SHAPE, RESIZE_SHAPE };
